import { render } from "./BlockCopy.vue?vue&type=template&id=42536146"
import script from "./BlockCopy.vue?vue&type=script&lang=js"
export * from "./BlockCopy.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mobilemediaru/cashforapp/cashforapp_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__